import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import * as paths from '../../../constants/pathConstants';
import { ESTABLISHMENT_STATUS } from '../../../constants/EstablishmentStatusEnumeration';
import { ESTABLISHMENT_STATE_RULES_ENUMERATION as establishmentEnumeration } from '../../../constants/EstablishmentStatusEnumeration';
import { ESTABLISHMENT_301_REQUIRED_ENUMERATION } from '../../../constants/EstablishmentStatusEnumeration';

import { is301Required } from '../../common/Utility';

class EstablishmentsRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      establishment_status: '',
      establishment_301_status: '',
      submission_id: ''
    };

    this.fetchEstablishmentData = this.fetchEstablishmentData.bind(this);
    this.getCaseDataRequired = this.getCaseDataRequired.bind(this);
  }

  componentDidMount() {
    
    let currentYear = new Date().getFullYear() - 1;
    let index = this.props.establishment.years_submitted
    ? this.props.establishment.years_submitted.indexOf(currentYear)
    : -1;
    let submission_link = '';
    let submission_id = '';
    
    if (index !== -1) {
      submission_link = this.props.establishment.links.submission_links[index];
      submission_id = submission_link.split('/').pop();
      this.setState({ submission_id });
    }
    
    this.fetchEstablishmentData();
  }

  componentDidUpdate(prevProps) {
    if ( prevProps.establishment.links !== this.props.establishment.links || prevProps.establishment.submission_status !== this.props.establishment.submission_status ) {
      let currentYear = new Date().getFullYear() - 1;
      let index = this.props.establishment.years_submitted
      ? this.props.establishment.years_submitted.indexOf(currentYear)
      : -1;
      let submission_link = '';
      let submission_id = '';
      
      if (index !== -1) {
        submission_link = this.props.establishment.links.submission_links[index];
        submission_id = submission_link.split('/').pop();
        this.setState({ submission_id });
      }
      this.fetchEstablishmentData();
    }
  }

  fetchEstablishmentData() {
    const { establishment } = this.props;

    // Submission Status VALUES
    const submissionStatusEnumeration = {
      NOT_ADDED: 1,
      ADDED: 2,
      SUBMITTED: 3,
    };

    // Combined submission status VALUES
    const combinedSubmissionStatusEnumeration = {
      NOT_SUBMITTED: 0,
      SUBMITTED: 1,
    };

    this.getCaseDataRequired(establishment)
      .then((caseDataRequired) => {
        let establishment_status = '';
        let establishment_301_status = '';

        // Set establishment_status based on submission_status
        if (establishment.submission_status == submissionStatusEnumeration.ADDED || establishment.submission_status == submissionStatusEnumeration.SUBMITTED) {

          if (establishment.submission_status == 3 && this.state.submission_id !== '') {
            establishment_status = (
              <Link
                to={
                  `${paths.pathToEstablishmentsDashboardPage}/${establishment.id}` +
                  `${paths.pathToSubmissionPage}/${this.state.submission_id}`
                }
              >
                Submitted
              </Link>
            );
          } else if (establishment.submission_status == submissionStatusEnumeration.ADDED) {
            establishment_status = 'Added';
          } else {
            establishment_status = 'Submitted';
          }
        } else {
          establishment_status = 'Not Submitted';
        }

        // Set establishment_301_status based on caseDataRequired and combined_submission_status
        if (caseDataRequired == ESTABLISHMENT_301_REQUIRED_ENUMERATION.NOT_REQUIRED) {

          establishment_301_status = 'Not Required to File';
        } else if (caseDataRequired == ESTABLISHMENT_301_REQUIRED_ENUMERATION.REQUIRED) {

          if (establishment.combined_submission_status == combinedSubmissionStatusEnumeration.NOT_SUBMITTED || typeof establishment.combined_submission_status == 'undefined') {

            if (establishment.submission_status == submissionStatusEnumeration.NOT_ADDED) {
              establishment_301_status = 'Pending 300A';
            } else if (establishment.submission_status == submissionStatusEnumeration.ADDED || establishment.submission_status == submissionStatusEnumeration.SUBMITTED) {
                if(typeof establishment.total_submitted_cases == 'undefined' || typeof establishment.expected_cases_count == 'undefined') {
                  establishment_301_status = 'Status Pending Update'
                } else {establishment_301_status = `${establishment.total_submitted_cases} ${ establishment.total_submitted_cases == 1 ? ' case out of ' : ' cases out of ' } ${establishment.expected_cases_count} added`;}}
          } else if (establishment.combined_submission_status == combinedSubmissionStatusEnumeration.SUBMITTED) {
            if(typeof establishment.total_submitted_cases == 'undefined' || typeof establishment.expected_cases_count == 'undefined') {
              establishment_301_status = 'Status Pending Update'
            } else {establishment_301_status = `${establishment.total_submitted_cases} ${ establishment.total_submitted_cases == 1 ? ' case out of ' : ' cases out of ' } ${establishment.expected_cases_count} submitted`;}}
        } else if (caseDataRequired == ESTABLISHMENT_301_REQUIRED_ENUMERATION.STATE_PLAN) {
          establishment_301_status = 'Please check your State Plan';
        }

        // Update state
        this.setState({
          establishment_status,
          establishment_301_status,
        });
      })
      .catch((error) => {
        console.error('Failed to determine case data required:', error);
      });
  }

  getCaseDataRequired(establishment) {
    return is301Required(establishment)
      .then((status) => {
        console.log(status);
        return status;
      })
      .catch((error) => {
        console.error('Error:', error);
        throw error;
      });
  }

  render() {
    const {
      establishment,
      onSelect,
      isSelected,
      evenRow,
      hideStatus,
    } = this.props;
    const { establishment_status, establishment_301_status } = this.state;

    let estabPrefix =
      establishment.establishment_status === 2 ? <i>[Inactive] </i> : '';

    return (
      <tr className={evenRow ? 'even-row' : ''}>
        <td>
          {establishment.establishment_status == 1 ? (
            <input
              type="checkbox"
              name="submit-reports"
              checked={isSelected}
              value={establishment.id}
              onChange={onSelect}
            />
          ) : null}
        </td>
        {!hideStatus && <td>{establishment_status}</td>}
        {!hideStatus && <td>{establishment_301_status}</td>}
        {!hideStatus ? (
          <td className="establishment-name">
            {estabPrefix}
            <Link
              to={`${paths.pathToEstablishmentsDashboardPage}/${establishment.id}`}
            >
              {establishment.establishment_name}
            </Link>
          </td>
        ) : (
          <td className="establishment-name">
            {estabPrefix}
            {establishment.establishment_name}
          </td>
        )}
        <td className="non-mobile">{establishment.address.street}</td>
        <td className="non-mobile">{establishment.address.city}</td>
        <td className="non-mobile">{establishment.address.state}</td>
        <td className="non-mobile">
          {establishment.address.zip.length == 5
            ? establishment.address.zip
            : establishment.address.zip.slice(0, 5) +
              '-' +
              establishment.address.zip.slice(5)}
        </td>
        <td className="non-mobile">
          {establishment.ein && establishment.ein.ein}
        </td>
      </tr>
    );
  }
}

EstablishmentsRow.propTypes = {
  establishment: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  evenRow: PropTypes.number,
  hideStatus: PropTypes.bool,
};

export default EstablishmentsRow;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentsTable/EstablishmentsRow.js
 **/